import { render, staticRenderFns } from "./Longitudinal.vue?vue&type=template&id=59503698&scoped=true"
import script from "./Longitudinal.vue?vue&type=script&lang=js"
export * from "./Longitudinal.vue?vue&type=script&lang=js"
import style0 from "./Longitudinal.vue?vue&type=style&index=0&id=59503698&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59503698",
  null
  
)

export default component.exports